export default __webpack_public_path__ + "static/2-eb8cee69fb33573ea0b9999d5fb8af45.jpg";